"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateFromZipcode = void 0;

var getStateFromZipcode = function getStateFromZipcode() {
  var dirtyZipcode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  // Cleanup
  var zipcode = dirtyZipcode.replace(/\D/gim, ""); // Ensure we have a zipcode or zipcode+4 input

  if (zipcode.length !== 5 && zipcode.length !== 9) return undefined; // State Checks

  if (/^340/.test(zipcode)) return "AA"; // Armed Forces - Americas

  if (/^09/.test(zipcode)) return "AE"; // Armed Forces - Eastern

  if (/^96[2-6]/.test(zipcode)) return "AP"; // Armed Forces - Pacific

  if (/^3[5-6]/.test(zipcode)) return "AL";
  if (/^99[5-9]/.test(zipcode)) return "AK";
  if (/^96799/.test(zipcode)) return "AS"; // Samoa

  if (/^8[5-6]/.test(zipcode)) return "AZ";
  if (/^71[6-9]|^72[0-9]/.test(zipcode)) return "AR";
  if (/^9[0-5]|^96[0-1]/.test(zipcode)) return "CA";
  if (/^8[0-1]/.test(zipcode)) return "CO";
  if (/^06/.test(zipcode)) return "CT";
  if (/^19[7-9]/.test(zipcode)) return "DE";
  if (/^200|^569/.test(zipcode)) return "DC";
  if (/^3[2-4]/.test(zipcode)) return "FL";
  if (/9694[1-4]/.test(zipcode)) return "FM"; // Federated States of Micronesia

  if (/^3[0-1]|^39[8-9]/.test(zipcode)) return "GA";
  if (/^969[1-2]|^9693[0-2]/.test(zipcode)) return "GU"; // Guam

  if (/^96[7-8]/.test(zipcode)) return "HI";
  if (/^83[2-9]/.test(zipcode)) return "ID";
  if (/^6[0-2]/.test(zipcode)) return "IL";
  if (/^4[6-7]/.test(zipcode)) return "IN";
  if (/^5[0-2]/.test(zipcode)) return "IA";
  if (/^6[6-7]/.test(zipcode)) return "KS";
  if (/^4[0-2]/.test(zipcode)) return "KY";
  if (/^70[0-9]|^71[0-5]/.test(zipcode)) return "LA";
  if (/^969[6-7]/.test(zipcode)) return "MH"; // Marshall Islands

  if (/^039|^04[0-9]/.test(zipcode)) return "ME";
  if (/^20[6-9]|^21[0-9]/.test(zipcode)) return "MD";
  if (/^01[0-9]|^02[0-7]|^055/.test(zipcode)) return "MA";
  if (/^4[8-9]/.test(zipcode)) return "MI";
  if (/^55[0-9]|^56[0-7]/.test(zipcode)) return "MN";
  if (/^38[6-9]|^39[0-7]/.test(zipcode)) return "MS";
  if (/^6[3-5]/.test(zipcode)) return "MO";
  if (/9695[0-2]/.test(zipcode)) return "MP"; // Northern Mariana Islands

  if (/^59/.test(zipcode)) return "MT";
  if (/^6[8-9]/.test(zipcode)) return "NE";
  if (/^889|^89[0-9]/.test(zipcode)) return "NV";
  if (/^03[0-8]/.test(zipcode)) return "NH";
  if (/^0[7-8]/.test(zipcode)) return "NJ";
  if (/^87[0-9]|^88[0-4]/.test(zipcode)) return "NM";
  if (/^1[0-4]|^005|^06390/.test(zipcode)) return "NY";
  if (/^2[7-8]/.test(zipcode)) return "NC";
  if (/^58/.test(zipcode)) return "ND";
  if (/^4[3-5]/.test(zipcode)) return "OH";
  if (/^7[3-4]/.test(zipcode)) return "OK";
  if (/^97/.test(zipcode)) return "OR";
  if (/^1[5-8]|^19[0-6]/.test(zipcode)) return "PA";
  if (/^00[6|7|9]/.test(zipcode)) return "PR";
  if (/^96939|^96940/.test(zipcode)) return "PW"; // Palau

  if (/^02[8-9]/.test(zipcode)) return "RI";
  if (/^29/.test(zipcode)) return "SC";
  if (/^57/.test(zipcode)) return "SD";
  if (/^37[0-9]|^38[0-5]/.test(zipcode)) return "TN";
  if (/^7[5-9]|^733|^885/.test(zipcode)) return "TX";
  if (/^84/.test(zipcode)) return "UT";
  if (/^05/.test(zipcode)) return "VT";
  if (/^201|^2[2-3]|^24[0-6]/.test(zipcode)) return "VA";
  if (/^008/.test(zipcode)) return "VI"; // Virgin Islands

  if (/^98|^99[0-4]/.test(zipcode)) return "WA";
  if (/^24[7-9]|^2[5-6]/.test(zipcode)) return "WV";
  if (/^5[3-4]/.test(zipcode)) return "WI";
  if (/^82|^83[0-1]/.test(zipcode)) return "WY"; // Nothing found? Return nothing

  return undefined;
};

exports.getStateFromZipcode = getStateFromZipcode;